/* AdvisoryDetailsViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AdvisoryDetailsViewRenderer");

class AdvisoryDetailsViewComponent extends EventEmitter {
    constructor(logger, gameEditor, state, userSession, MUF, AdvisoryEntity) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._advisoryID = state.advisoryId;
        this._advisoryFeed = undefined;
        this._advisoryEntity = AdvisoryEntity;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerDeviceListeners() {
        this._advisoryFeed.on("PristinePropertiesChanged", (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this)));
    }

    _unregisterDeviceListeners() {
        this._advisoryFeed.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (!_.isUndefined(this._advisoryFeed)) {
            this._unregisterDeviceListeners();
        }

        let shutdowns = [this._renderer.shutdown(), _.isUndefined(this._advisoryFeed) ? Promise.resolve() : this._advisoryFeed.shutdown()];

        return Promise.all(shutdowns).then(
            () => {
                this._advisoryFeed = undefined;
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._advisoryEnitity = undefined;
                this._advisoryID = undefined;
                this._activeOrgId = undefined;
            },
            (err) => {
                this._logger.warn(err, "AdvisoryDetailsViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onPristinePropertiesChanged(pristineProperties, before) {
        this.emit("PristinePropertiesChanged", pristineProperties, before);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenDeviceIsReady()
            .then(() => {
                return this._advisoryEntity.load(this._activeOrgId, "Advisory", this._advisoryID, {});
            })
            .then((advisoryData) => {
                this._advisoryFeed = advisoryData;
                return Promise.resolve();
            })
            .then(() => {
                this._registerDeviceListeners();
            })
            .catch((err) => {
                this._logger.warn(err, "AdvisoryDetailsViewComponent.whenModelIsReady() error");
                this._modalUserFeedback.displayError({
                    errorMsg: "This device cannot be opened.",
                    errorCode: ""
                });
                return Promise.reject(err);
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = AdvisoryDetailsViewComponent;

AdvisoryDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.viewState",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.entities.Advisory"
];

AdvisoryDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "Advisory Details",
    icon: "devicemanager.cisco_smartnet",
    shown: true
};
